var _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 759,
    height: 2,
    viewBox: "0 0 759 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 1,
    x2: 759,
    y2: 1,
    stroke: "#EEFFF6",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine40);
export default __webpack_public_path__ + "static/media/line-40.516feb2f4b2c63768f6addb10dc25071.svg";
export { ForwardRef as ReactComponent };